<!-- 测评延期 -->
<template>
  <div class="yxtbiz-eval-delay">
    <yxt-drawer
      :title="$t('pc_gwnl_eval_evalDelay' /*测评延期*/)"
      :destroy-on-close="true"
      :visible.sync="dialogVisible"
      :before-close="beforeDrawClose"
      size="640px"
    >
    <yxt-blockhead :title="$t('pc_eval_baseinfo').d('基本信息')"  size='small' type="special"></yxt-blockhead>
      <div v-loading="loading" class="ml16 mt16 mr26">
        <yxt-form
          ref="delayForm"
          :model="delayForm"
          :rules="rules"
          label-position="top"
          size="small"
        >
          <yxt-form-item
            :label="$t('pc_gwnl_global_lbl_projectName'/* 方案名称 */)"
            prop="name"
          >
            <yxt-input
              v-model="delayForm.name"
              :rows="5"
              :placeholder="$t('pc_gwnl_global_enterProjectName').d('请输入方案名称')"
              maxlength="50"
              show-word-limit
            />
          </yxt-form-item>
          <yxt-form-item
            :label="$t('pc_gwnl_eval_lbl_evalTime')"
            prop="evalTime"
          >
            <yxt-date-picker
              v-model="delayForm.evalTime"
              type="datetimerange"
              size="small"
              style="width: 100%;"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              :range-separator="$t('pc_gwnl_eval_to')"
              :start-placeholder="$t('pc_gwnl_eval_startTime')"
              :end-placeholder="$t('pc_gwnl_eval_endTime')"
            />
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_gwnl_global_lbl_projectDesc')">
            <yxt-input
              v-model="delayForm.description"
              type="textarea"
              :rows="3"
              maxlength="200"
              :placeholder="$t('pc_gwnl_global_enterProjectDesc')"
              show-word-limit
              resize="none"
            />
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_gwnl_global_remarks')">
            <yxt-input
              v-model="delayForm.remark"
              type="textarea"
              resize="none"
              maxlength="200"
              :rows="3"
              :placeholder="$t('pc_gwnl_eval_enterRemark')"
              show-word-limit
            />
          </yxt-form-item>
          <yxt-form-item prop="autoIssueReport" class="eval-remark1" v-show="!isBehavior">
            <yxt-checkbox
              v-model="delayForm.autoIssueReport"
              :true-label="1"
              :false-label="0"
              @change="msgTypeChange"
            >
              <!-- 报告生成后自动下发给学员 -->
              {{ $t('pc_eval_eval_seting_tips') }}
            </yxt-checkbox>
          </yxt-form-item>
        </yxt-form>
      </div>
      <div slot="footer">
        <yxt-button @click="beforeDrawClose">
          {{ $t('pc_biz_common_cancel_mini') }}
        </yxt-button>
        <yxt-button
          type="primary"
          @click="submitdelay"
        >
          {{ $t('pc_biz_labelling_confirm') }}
        </yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import { postEvalInfo, getEvalInfo } from './service.js';
import dayjs from 'dayjs';

export default {
  name: 'YxtbizEvalDelay',
  name_zh: '测评延期组件',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      desc: '组件的显隐',
      setter: 'BooleanSetter'
    },
    id: {
      type: String,
      default: '',
      desc: '测评的id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      rules: {
        name: [
          { required: true, message: this.$t('pc_gwnl_eval_fillEvalName'), trigger: 'blur' }
        ],
        time: [{ required: true, message: this.$t('pc_gwnl_eval_pleaseSelectEvalTime'), trigger: 'blur' }],
        description: [{ max: 200, message: this.$t('pc_gwnl_eval_lengthWithin200'), trigger: 'blur' }],
        remark: [{ max: 200, message: this.$t('pc_gwnl_eval_lengthWithin200'), trigger: 'blur' }],
        evalTime: [
          { required: true, validator: this.validateTime, trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate: (time) => {
          console.log(time.getTime(), dayjs().valueOf());
          return false;
        }
      },
      delayForm: {
        autoIssueReport: '',
        name: '',
        description: '',
        evalTime: null,
        remark: ''
      },
      loading: false,
      isBehavior: false
    };
  },
  watch: {
    id: {
      handler(newValue) {
        newValue && this.initData(newValue);
      },
      immediate: true
    }
  },
  methods: {
    initData(id) {
      getEvalInfo(id).then(res => {
        this.delayForm.name = res.name;
        this.delayForm.description = res.description;
        this.delayForm.remark = res.remark;
        this.delayForm.evalTime = [res.startTime, res.endTime];
        this.delayForm.type = res.type;
        // 评估方案类型(1-行为,2-问卷,3-人格,4-多次行为)
        if ([1, 4].includes(res.type)) {
          this.delayForm.autoIssueReport = 0;
          this.isBehavior = true;
        } else {
          this.delayForm.autoIssueReport = res.autoIssueReport || 0;
        }
        this.delayForm.scene = res.scene;
      });
    },
    validateTime(rule, value, callback) {
      console.log(value);
      if (value && value.length !== 0) {
        // const ed = value[1]
        if (dayjs().isAfter(value[1], 'time')) {
          callback(new Error(this.$t('pc_gwnl_eval_closeTime_currentTime')));
        } else {
          callback();
        }
      } else {
        callback(new Error(this.$t('pc_gwnl_eval_pleaseSelectEvalTime')));
      }
    },
    msgTypeChange() {
      if (this.delayForm.autoIssueReport) {
        this.$confirm(this.$t('pc_gwnl_eval_auto_send_report_tips'), this.$t('pc_biz_lbl_tip'), {
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: this.$t('pc_gwnl_global_msg_known')
        });
      }
    },
    beforeDrawClose() {
      this.$confirm(this.$t('pc_gwnl_eval_isGiveUpChange'), this.$t('pc_biz_lbl_tip'), {
        confirmButtonText: this.$t('pc_biz_labelling_confirm'),
        cancelButtonText: this.$t('pc_biz_common_cancel_mini'),
        type: 'warning'
      }).then(() => {
        this.$emit('update:dialog-visible', { dialogVisible: false });
      });
    },
    async submitdelay() {
      this.$refs.delayForm.validate((valid) => {
        if (valid) {
          this.postEvalInfo();
        } else {
          return false;
        }
      });
    },
    postEvalInfo() {
      const { name, remark, description, autoIssueReport, type, scene } = this.delayForm;
      const data = {
        autoIssueReport,
        name,
        description,
        remark,
        startTime: this.delayForm.evalTime[0],
        endTime: this.delayForm.evalTime[1],
        type,
        scene,
        id: this.id
      };
      postEvalInfo(data).then((res) => {
        this.$emit('update:dialog-visible', { dialogVisible: false, isRefresh: true });
        // this.$emit('beforeDrawClose', { dialogVisible: false, isRefresh: true })
      }).catch((err) => {
        err.error &&
        err.error.message &&
        this.$message.error(err.error.message);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.yxtbiz-eval-delay{
  ::v-deep .yxt-date-editor .yxt-range-separator {
  padding: 0;
}
}
</style>
